export const onSelectAll = (
  event: React.FocusEvent<HTMLInputElement, Element>
) => {
  event.target.select();
};
